import { MutationHookOptions, useMutation } from '@apollo/client';

import { DELETE_GROUP } from './mutations';

export const useDeleteGroup = (options?: MutationHookOptions) => useMutation(DELETE_GROUP, options);
